import template from './b360FilterBar.html';
import _ from 'lodash';

export function b360FilterBarDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: b360FilterBarController,
    controllerAs: 'b360FilterBar',
    bindToController: true,
    scope: {
      filtersData: "=",
      teamLeader: "=?",
      onNewSelections: '&',
    }
  };
}

const sum = (a, b) => a + b;
class b360FilterBarController {
  constructor($scope) {
    'ngInject';

    this.callbackDebounce;
    this.$scope = $scope;
    this.selectedGroups = {};
    this.selectedClients = {};
    this.selectedTeams = {};
    this.$scope.$watch(() => this.filtersData, (prev, curr) => !_.isEqual(prev, curr) && this.setup());
    this.initial = true;
  }

  callCallback() {
    clearTimeout(this.callbackTimeout);
    this.callbackTimeout = setTimeout(() => {
      const newData = {
        clients: Object.keys(this.selectedClients).filter(key => this.selectedClients[key]),
        groups: Object.keys(this.selectedGroups).filter(key => this.selectedGroups[key]),
        teams: this.selectedTeams
      };
      this.onNewSelections({newData});
      clearTimeout(this.callbackTimeout);
    }, 50);
  }

  treeChanged(selectedClients) {
      this.selectedClients = selectedClients;

      this.callCallback();
  }

  teamsChanged(changedProps) {
    if (!changedProps || (!changedProps.length && !this.teamLeader)) {
      this.callCallback();
      return;
    }

    const selectedTeams = Object.keys(this.selectedTeams).filter(key => !!this.selectedTeams[key]);

    // hack to influence clients/groups from teams starts here...
    // this.groups.forEach(g => g.value = 0);
    // this.groups.forEach(g => g.clients.forEach(c => c.value = 0));
    // this.filtersData.employees.data.forEach(emp => {
    //   if (!emp.parentIds.filter(parentId => selectedTeams.includes(parentId)).length) {
    //     return;
    //   }
    //   emp.durationClients.map(empClient => {
    //     this.groups.forEach(group => {
    //       group.clients.forEach(client => {
    //         if (client.id === empClient.client.id) {
    //           group.value += empClient.value;
    //           client.value += empClient.value;
    //         }
    //       });
    //     });
    //   });
    // });
    // ..ends here.


    const selection = [];
    this.filtersData.employees.data.forEach(emp => {
      const inSelTeams = emp.parentIds.filter(parentId => !selectedTeams.length ? true : selectedTeams.includes(parentId));

      if (!inSelTeams.length) {
        return;
      }

      const sumOfEmployeeTimesForSelectedClients = inSelTeams.reduce((acc, teamId) => {
          return acc + emp.durationClients
            .filter((x) => !selectedTeams.length ? true : x.team.id == teamId)
            .filter((x) => this.selectedClients[x.client.id])
            .map((x) => !selectedTeams.length ? 0 : x.value)
            .reduce(sum, 0);
        }, 0);

      selection.push({
        id: emp.id,
        name: emp.name,
        value: sumOfEmployeeTimesForSelectedClients
      });
    });

    this.employees = selection;
    this.callCallback();
  }

  setup() {
    if (!this.filtersData) {
      return;
    }

    this.selectedGroups = {};
    this.selectedClients = {};
    this.selectedTeams = {};
    this.groups = angular.copy(this.filtersData.groups.data);
    this.teams = angular.copy(this.filtersData.teams.data);
    this.anySelected = false;
    this.employees = [];
    this.groups.forEach(group => {
      group.clients.forEach(client => {
        this.selectedClients[client.id] = !!client.preSelected || client.external;
        if(!this.anySelected && (!!client.preSelected || client.external)){
          this.anySelected = true;
        }
      });
    });

    this.teams = this.filtersData.teams.data.map((teamData) => {
      const value = teamData.durationClients
        .filter((x) => this.selectedClients[x.client.id])
        .map((x) => x.value)
        .reduce(sum, 0);
      return {id: teamData.id, name: teamData.name, value, preSelected: teamData.preSelected };
    });

    this.teams.forEach(item => this.selectedTeams[item.id] = !!item.preSelected);
    let selectedTeams = Object.keys(this.selectedTeams).filter(key => !!this.selectedTeams[key]).map(key => ({
      property: key,
      val: !!this.selectedTeams[key]
    }));

    if (!selectedTeams.length) {
      this.teams.forEach(team => this.selectedTeams[team.id] = true);
    }

    if (!selectedTeams.length)
      this.teams = this.teams.map(team => ({...team, value: 0}));

    if(this.initial && !this.anySelected){
      Object.keys(this.selectedClients).forEach( key => {
          this.selectedClients[key] = true;
      });
    }
    this.initial = false;
  }
}
